import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { deleteEmail, loadeEmails } from '../utils/Network';
import { buildPaginationItems } from '../utils/cmsPagination';

export default function EmailsContent({ page, urlParams }) {
    const currentPage = Number(page) || 1;
    const [loading, setLoading] = useState(0);
    const [pageloading, setPageLoading] = useState(false);
    const [emails, setEmails] = useState(null);
    const [emails_count, setEmailsCount] = useState(null);
    const [show_delete, setShowDelete] = useState(false);
    const [pages, setPages] = useState(null);

    const getData = useCallback(() => {
        setPageLoading(true);
        loadeEmails(currentPage).then((data) => {
            if (data.results) {
                setEmails(data.results);
            }
            const totalCount = Number(data.count) || 0;
            setEmailsCount(totalCount);
            if (totalCount > 0) {
                const pageCount =
                    totalCount % 10 === 0 ? parseInt(totalCount / 10, 10) : parseInt(totalCount / 10, 10) + 1;
                setPages(range(1, pageCount));
            } else {
                setPages([]);
            }
            setPageLoading(false);
        });
    }, [currentPage]);

    useEffect(() => {
        getData();
    }, [getData]);

    function range(start, end) {
        return Array.apply(0, Array(end)).map((element, index) => index + start);
    }

    const handleDelete = (id) => {
        setLoading(id);
        deleteEmail(id).then(() => {
            setLoading(0);
            getData();
        });
    };

    const showDelete = (e) => {
        e.preventDefault();
        setShowDelete(!show_delete);
    };

    const totalPages = pages?.length || 0;
    const canGoPrev = totalPages > 0 && currentPage > 1;
    const canGoNext = totalPages > 0 && currentPage < totalPages;
    const queryString = urlParams.toString();
    const qs = queryString ? `?${queryString}` : '';
    const paginationItems = useMemo(() => {
        if (!totalPages) return [];
        return buildPaginationItems(currentPage, totalPages);
    }, [currentPage, totalPages]);

    return (
        <>
            <div className="content-wrapper">
                <section className="content-header" style={{ maxWidth: '1550px' }}>
                    <h3 className="box-title mb-10">
                        <span className="sr-only">Emails</span>
                    </h3>
                    <ol className="breadcrumb">
                        <li>
                            <a href="/cms">
                                <i className="fa fa-dashboard"></i> Home
                            </a>
                        </li>
                        <li className="active">Emails</li>
                    </ol>
                </section>

                <section className="content">
                    <div className="container-fluid" style={{ maxWidth: '1400px' }}>
                        <div className="row users-filter-page-row">
                            <div className="col-md-12 users-filter-page-col">
                                <div className="box box-primary">
                                    <div className="box-header with-border">
                                        <h3 className="box-title">
                                            All emails
                                            {emails_count != null && (
                                                <span style={{ fontSize: 11, marginLeft: '0.35em' }}>
                                                    ({emails_count})
                                                </span>
                                            )}
                                        </h3>
                                        <a
                                            href="/cms/email"
                                            title="Send new email"
                                            className="btn btn-cm margin-r-5 pull-right"
                                        >
                                            <i className="fa fa-plus"></i>
                                        </a>
                                        <button
                                            type="button"
                                            title="Show Delete Button"
                                            className="btn btn-cm margin-r-5 pull-right"
                                            onClick={showDelete}
                                        >
                                            <i className="fa fa-trash"></i>
                                        </button>
                                    </div>
                                    <div className="box-body no-padding">
                                        <table
                                            id="example1"
                                            className={`table table-striped mb-0${pageloading ? ' opacity-70' : ''}`}
                                        >
                                            <thead>
                                                <tr>
                                                    <th>To</th>
                                                    <th>Subject</th>
                                                    <th>Date</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emails?.map((item) => (
                                                    <tr
                                                        key={item.id}
                                                        className={loading === item.id ? 'loading' : ''}
                                                    >
                                                        <td>
                                                            <p className="mb-0">
                                                                <a href={`/cms/email/${item.id}`} className="link-color">
                                                                    {item.to}
                                                                </a>
                                                            </p>
                                                        </td>
                                                        <td>{item.subject}</td>
                                                        <td>
                                                            {item.created_at.split('T')[0]}
                                                            <br />
                                                            {item.created_at.split('T')[1].split('.')[0]}
                                                        </td>
                                                        <td>
                                                            <div className="btn-group">
                                                                {show_delete && (
                                                                    <>
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => {
                                                                                if (
                                                                                    window.confirm(
                                                                                        'Are you sure you wish to delete this item?'
                                                                                    )
                                                                                ) {
                                                                                    handleDelete(item.id);
                                                                                }
                                                                            }}
                                                                            className="btn btn-cm btn-sm"
                                                                        >
                                                                            <i className="fa fa-trash"></i>
                                                                        </button>
                                                                        <a
                                                                            href={`/cms/email/${item.id}`}
                                                                            className="btn btn-cm btn-sm mx-1"
                                                                        >
                                                                            <i className="fa fa-edit"></i>
                                                                        </a>
                                                                    </>
                                                                )}
                                                                {!show_delete && (
                                                                    <a
                                                                        href={`/cms/email/${item.id}`}
                                                                        className="btn btn-cm btn-sm"
                                                                    >
                                                                        <i className="fa fa-edit"></i>
                                                                    </a>
                                                                )}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th>To</th>
                                                    <th>Subject</th>
                                                    <th>Date</th>
                                                    <th></th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                        {!emails?.length && !pageloading && (
                                            <div className="padding-10 text-muted">No emails found.</div>
                                        )}
                                    </div>
                                </div>

                                {pages && pages.length > 1 && (
                                <ul className="pagination cms-pagination m-0 float-right">
                                    <li className={`page-item${!canGoPrev ? ' disabled' : ''}`}>
                                        <a
                                            className="page-link"
                                            href={canGoPrev ? `/cms/emails/${currentPage - 1}${qs}` : '#'}
                                            onClick={!canGoPrev ? (e) => e.preventDefault() : undefined}
                                            aria-disabled={!canGoPrev}
                                        >
                                            «
                                        </a>
                                    </li>
                                    {paginationItems.map((entry, idx) => (
                                        <li
                                            key={entry === 'ellipsis' ? `e-${idx}` : entry}
                                            className="page-item"
                                        >
                                            {entry === 'ellipsis' ? (
                                                <span
                                                    className="page-link disabled"
                                                    style={{ border: 'none', background: 'transparent' }}
                                                >
                                                    …
                                                </span>
                                            ) : (
                                                <a
                                                    className={
                                                        entry === currentPage ? 'page-link active' : 'page-link'
                                                    }
                                                    href={`/cms/emails/${entry}${qs}`}
                                                >
                                                    {entry}
                                                </a>
                                            )}
                                        </li>
                                    ))}
                                    <li className={`page-item${!canGoNext ? ' disabled' : ''}`}>
                                        <a
                                            className="page-link"
                                            href={canGoNext ? `/cms/emails/${currentPage + 1}${qs}` : '#'}
                                            onClick={!canGoNext ? (e) => e.preventDefault() : undefined}
                                            aria-disabled={!canGoNext}
                                        >
                                            »
                                        </a>
                                    </li>
                                </ul>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
}
